const 	ua 		= window.navigator.userAgent.toLowerCase(),
		appver 		= window.navigator.appVersion.toLowerCase();
let isLegacy 	= appver.indexOf("msie 8.0") > -1 || appver.indexOf("msie 9.0") > -1 || appver.indexOf("msie 10.0") > -1,
	isIE 		= ua.indexOf("msie") !== -1 || navigator.userAgent.match(/Trident/),
	isIE11 		= navigator.userAgent.toLowerCase().indexOf('trident/7') > -1,
	isAndroid 	= navigator.userAgent.match(/Android/i),
	isIPhone 	= navigator.userAgent.match(/iPhone/i),
	isSP 		= navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i),
	isIPad 		= navigator.userAgent.match(/iPad/i),
	isFF 		= ua.indexOf("firefox")!== -1,
	isEdge 		= ua.indexOf("applewebkit") > -1 && ua.indexOf("edge") > -1,
	isMobile	= true,
	isSmallScreen = false,
	isPC = true;

if(isAndroid || isIPhone || isIPad){
	isPC = false;
}else{
	isPC = true;
}
var $html = document.documentElement;
//win or mac
if( navigator.userAgent.indexOf("Win") !== -1 ){
	let ary = ["os_windows"];
	if(isFF){
		ary.push("firefox");
	}else{
		if(isIE){
			if(isIE11){
				ary.push("ie11");
			}
		}else if(isEdge){
			ary.push("edge");
		}else{
		}
	}
	addClassToBody(ary);
}
if(navigator.userAgent.indexOf("Mac") !== -1 ){
	let ary = ["os_mac"];
	if(isFF){
		ary.push("firefox");
	}else{
		if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1){
			ary.push("safari");
		}else{
			ary = ["os_mac"];
		}
	}
	addClassToBody(ary);
}
function addClassToBody(ary){
	for(let i = 0; i < ary.length; i++){
		$html.classList.add(ary[i]);
	}
}
var mouse = [];
function object(o) {
	var f = object.f, i, len, n, prop;
	f.prototype = o;
	n = new f;
	for (i=1, len=arguments.length; i<len; ++i){
		for (prop in arguments[i]){
			n[prop] = arguments[i][prop];
		}
	}
	return n;
}
object.f = function(){};

var observer;
var ioArry = [
	{
		"target": ".a",
		"margin": '0px 0px 0px 0px',
		"threshold": [0, 1],
		"change": function(entries){
			//ヘッダーの固定、固定解除-----------------------------------
			let $header = $("header#global_header");
			entries.forEach( function(entry, index){
				let idx = $(".a").index(entry);
				var $block = $(".a").eq(idx);
				observer.unobserve(element);
				if(!$block.hasClass("animate")){
					$block.addClass("animate");
					setTimeout(function(){
						$block.addClass("animated");
					},1000);
				}
			});
		}
	}
]

var is_detail_to_sort = false;
var page = {
	lang: "",
	param: "",
	currentURL : [],
	folder: "",
	searchCat: "",
	type: "",
	currentParam: function(){
		let pair = this.param.split('&');
		let isMap 		= false;
		let hasParam 	= false;
		let hasType 	= false;
		page.type = "";
		page.param = "";
		for(var i = 0; pair[i]; i++) {
			var kv = pair[i].split('=');
			if(kv[0] === "search"){
				page.searchCat = kv[1];
				page.param = pair;
				hasParam = true;
			}else if(kv[0] === "type"){
				page.type = kv[1];
				page.param = pair;
				hasParam = true;
				hasType = true;
			}else if(kv[0] === "map"){
				isMap = true;
				hasParam = true;
				page.param = "map";
			}else if(kv[0] === "ckcachecontrol"){
				
			}
		}
		if(hasParam){
			/*
			let target = "ckcachecontrol"
			page.param.some(function(v, i){
				if ( v.indexOf(target) != -1){
					page.param.splice(i,1);
				}
			});
			*/
		}else{
			page.type = "";
		}
		
		if(!isMap){
			$("body").removeClass("is_mapview");
		}
		fw.checkSearchNav();
		
		//console.log(pair)
	},
	urlLength: function (){
		return page.currentURL.length;
	},
	getLang: function(){
		let prop 	= location.pathname,
			arry 	= prop.split("/"),
			len 	= arry.length;
		page.lang = arry[1];
		//console.log("currentLang:", page.lang);
		return page.lang;
	}
}

var load = {
	getJson: function(url,params){
		var defer 	= $.Deferred();
		var url 	= url;
		$.ajax({
			type 		: "GET",
			dataType	: 'json',
			url 		: url,
			data 		: params,
			success		: defer.resolve,
			error 		: defer.reject
		});
		return defer.promise();
	}
}
var transitionEndEvents = 'transitionend webkitTransitionEnd';
